<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="67.3803mm"
    height="32.2919mm"
    version="1.1"
    style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
    viewBox="0 0 25055.77 12007.94"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <style type="text/css">
        <![CDATA[
         .fil0 {fill:#373435}
        ]]>
      </style>
    </defs>
    <g id="Camada_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M6003.65 0l13048.46 0c3302.27,0 6003.65,2701.72 6003.65,6003.65l0 0.63c0,3301.93 -2701.72,6003.65 -6003.65,6003.65l-13048.46 0c-3301.93,0 -6003.65,-2701.42 -6003.65,-6003.65l0 -0.63c0,-3302.23 2701.42,-6003.65 6003.65,-6003.65zm11105.59 8091.66c0,-642.9 520.75,-1163.65 1163.65,-1163.65 642.94,0 1163.69,520.75 1163.69,1163.65 0,642.94 -520.75,1163.69 -1163.69,1163.69 -642.9,0 -1163.65,-520.75 -1163.65,-1163.69zm3293.12 -3293.12c642.94,0 1163.69,520.75 1163.69,1163.65 0,642.94 -520.75,1163.69 -1163.69,1163.69 -642.94,0 -1163.69,-520.75 -1163.69,-1163.69 0,-642.9 520.75,-1163.65 1163.69,-1163.65zm-4258.94 0c642.94,0 1163.69,520.75 1163.69,1163.65 0,642.94 -520.75,1163.69 -1163.69,1163.69 -642.9,0 -1163.65,-520.75 -1163.65,-1163.69 0,-642.9 520.75,-1163.65 1163.65,-1163.65zm965.82 -965.82c0,-642.9 520.75,-1163.65 1163.65,-1163.65 642.94,0 1163.69,520.75 1163.69,1163.65 0,642.94 -520.75,1163.69 -1163.69,1163.69 -642.9,0 -1163.65,-520.75 -1163.65,-1163.69zm-13036.56 2129.81l0 -0.33c0,-502.82 411.12,-913.95 913.98,-913.95l1205.11 0 0 -1204.81c0,-502.86 411.16,-913.98 913.98,-913.98l0.33 0c502.82,0 913.95,411.12 913.95,913.98l0 1204.81 1204.81 0c502.86,0 913.98,411.12 913.98,913.95l0 0.33c0,502.82 -411.12,913.95 -913.98,913.95l-1204.81 0 0 1205.15c0,502.82 -411.12,913.98 -913.95,913.98l-0.33 0c-502.82,0 -913.98,-411.16 -913.98,-913.98l0 -1205.15 -1205.11 0c-502.86,0 -913.98,-411.12 -913.98,-913.95z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IcoGame',
}
</script>
